/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Summary card for an expert, returned by the matching and last-session tools and
 * rendered by the client during the booking flow.
 */
export interface AiGuideBotModelsExpertCardData {
  /** Short label on the card (e.g. "Best Match" or "Recommended"). */
  caption?: null | string;
  /** Short profile description used to introduce the expert. */
  description?: null | string;
  /** Expert's first name, shown on the card and in confirmations. */
  expertFirstName?: null | string;
  /** Unique identifier of the expert, used as the key for availability and booking. */
  expertId?: null | string;
  /** Expert's last name. */
  expertLastName?: null | string;
  /** URL of the expert's profile image. */
  imageUrl?: null | string;
  /** Optional client-side selection key, set when the card is returned as a choice option. */
  key?: null | string;
  /** Language codes the expert can deliver sessions in. */
  languageCodes: string[];
  /** Public profile page URL for the expert. */
  profileUrl?: null | string;
  /** Expert's specialisation, localised to the requested language. */
  specialisation?: null | string;
  /** Comma-separated list of the expert's top topics, localised. */
  topics?: null | string;
}

/** Input for content lookup when the user asks for wellbeing material. */
export interface AiGuideBotModelsSearchContentRequest {
  /**
   * Optional content type filter.
   * Set this only when the user explicitly asks for a format (for example, article or video).
   */
  contentType?: null | string;
  /**
   * Language code used to filter results, such as `en-GB` or `nl-NL`.
   * Keep this aligned with the user's mentioned language.
   */
  language: string;
  /**
   * Zero-based page number for pagination.
   * Start with `0` and increment only if more results are needed.
   * @format int32
   */
  pageIndex: number;
  /**
   * Main user topic or question to search for.
   * Prefer the user's exact wording from the latest turn.
   */
  topic: string;
  /**
   * Id of the end user the search is performed for, used by the service-authenticated v2
   * endpoint. Required for content that is gated per user, such as audio exercises; omit it and
   * that content is left out of the results.
   * The v1 endpoint ignores this and takes the user from the caller's own bearer token.
   */
  userId?: null | string;
}

/** Request model for patching a conversation's mutable fields. */
export interface AiGuideBotModelsUpdateConversationRequest {
  /** The new conversation title. */
  title: string;
}

/** Request model for updating an existing conversation message's metadata. */
export interface AiGuideBotModelsUpdateMessageRequest {
  /** Optional message-type discriminator (e.g. a choice-prompt type). */
  messageType?: null | string;
  /** Optional metadata key/value pairs to merge onto the message (e.g. marking a choice as responded). */
  metadata?: null | object;
  /** Optional structured payload associated with the message type. */
  payload?: null;
  /** Optional replacement text for the message. */
  text?: null | string;
}

/**
 * Contains all validated details required to finalize a session booking.
 * Ensure all fields are derived from the current conversation state and confirmed by the user before submission.
 */
export interface AiGuideBotRequestsBookSessionRequestV2 {
  /** The unique identifier of the selected expert for this session. */
  expertId: string;
  /** Preferred session language code (e.g., 'en-US' or 'nl-NL') as confirmed by the user. */
  language: string;
  /**
   * Chosen UTC start time for the session, picked from available expert slots.
   * @format date-time
   */
  sessionDateTime: string;
  /** Session type (e.g., 'general' or 'physical-wellbeing') that matches the user's need. */
  sessionType: string;
  /** The user's preferred time zone used for confirming the final slot timing. */
  timezone: string;
  /** The end user the session is booked for. Supplied explicitly by the AI Coach (sourced from the request it received) rather than derived from a forwarded user token, under service-to-service auth (security-enhancements.md s6c). */
  userId: string;
}

/**
 * Body of a chat-bot streaming request: the full client-owned message history plus
 * the caller's time zone, forwarded to the AI Coach.
 */
export interface AiGuideBotRequestsSendConversationMessageRequest {
  /** The user's time zone (IANA or Windows), used to localise session times. */
  clientTimezone: string;
  /** The conversation messages, sent in full by the client on every turn. */
  messages: AiGuideBotRequestsSendConversationMessageRequestMessage[];
}

/** A single message within a AiGuideBot.Requests.SendConversationMessageRequest. */
export interface AiGuideBotRequestsSendConversationMessageRequestMessage {
  /**
   * When the message was created on the client.
   * @format date-time
   */
  createdAt: string;
  /** Client-owned message identifier (e.g. the Vercel AI SDK message id). */
  id: string;
  /**
   * The Vercel AI SDK UI message metadata object (e.g. the user's device context under
   * `clientInfo` for usage reporting). Loosely typed and forwarded verbatim to the
   * AI Coach; only the client (producer) and the AI Coach (consumer) interpret its shape.
   */
  metadata?: null;
  /**
   * The message content as Vercel AI SDK UI message parts (e.g. `text` and
   * `data-*` parts). Loosely typed because the shape is owned by the client SDK and
   * forwarded verbatim to the AI Coach.
   */
  parts: any[];
  /** Message role: `user` or `assistant`. */
  role: OpenUpAiCoachApiContractsApiChatMessageRole;
}

/**
 * Contains the details needed to submit a help desk support request on behalf of the user.
 * The endpoint generates a conversation summary internally and emails it to the support team.
 * Only call this after the user has explicitly confirmed they want their request submitted.
 */
export interface AiGuideBotRequestsSubmitHelpDeskRequestV2 {
  /**
   * The current chat conversation identifier, included for tracing and metadata on the generated summary.
   * @format uuid
   */
  conversationId: string;
  /** The conversation transcript to summarize and email to the support team. */
  conversationTranscript: string;
  /** The end user the request is submitted on behalf of. Supplied explicitly by the AI Coach (sourced from the request it received) rather than derived from a forwarded user token, under service-to-service auth (security-enhancements.md s6c). */
  userId: string;
}

/**
 * Confirms the details of a successfully booked session.
 * Use this data to provide a final summary and reassure the user that their appointment is scheduled.
 */
export interface AiGuideBotResponsesBookSessionResponse {
  /**
   * The unique identifier for the booked consult.
   * @format int32
   */
  consultId: number;
  /** The unique identifier of the assigned expert. */
  expertId: string;
  /** Optional URL for the expert's profile picture to enhance the confirmation message. */
  expertImageUrl?: null | string;
  /** The first name of the expert for the booked session. Use this to confirm the expert to the user. */
  expertName: string;
  /** Public profile link for the expert, provided for the user's reference. */
  expertProfileUrl: string;
  /**
   * The confirmed UTC start time for the session. Use this to inform the user of their appointment time.
   * @format date-time
   */
  sessionDateTime: string;
  /** The language confirmed for the session. */
  sessionLanguage: string;
  /** The confirmed session type. */
  sessionType: string;
  /** The user's preferred time zone for the booking. */
  timezone: string;
}

export interface AiGuideBotResponsesConversationMessageResponseV2 {
  /** @format date-time */
  createdAt: string;
  id: string;
  metadata?: null | object;
  parts: any[];
  role: string;
}

/**
 * Provides information about the user's most recent completed session.
 * Use this to suggest the same expert for follow-up appointments or to acknowledge their history with OpenUp.
 */
export interface AiGuideBotResponsesGetLastSessionResponse {
  /** Indicates if a matching completed session was found. If false, treat the user as new to this session type. */
  hasPreviousSession: boolean;
  /** The details of the expert from the last session. Use this to offer a 'book again' option with a known face. */
  previousSessionExpert?: AiGuideBotModelsExpertCardData | null;
}

export interface ConfirmUserParams {
  /** User verification code */
  token?: string;
}

export interface FindMatchingExpertsParams {
  /** Language code used to filter experts and localize returned fields. */
  language?: string;
  /** Short user summary used for semantic matching against expert profiles. */
  matchingCriteria?: string;
  /** Session type used to restrict matches to relevant experts. */
  sessionType?: string;
}

export interface GetAudioListParams {
  audience?: string;
  contentGroups?: string[];
  languageCode: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
}

export interface GetAutocompleteParams {
  languageCode?: string;
  /** @format int32 */
  limit?: number;
  q?: string;
}

export interface GetBookmarkedContentsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetContentsV2Params {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetConversationsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetExpertFirstAvailableTimeSlotsParams {
  /** Selected expert identifier from the current booking flow. */
  expertId: string;
  /**
   * The earliest UTC date and time to start searching for available slots. Use this if the user requests availability after a specific moment.
   * @format date-time
   */
  fromDateTime?: string;
  /** User's time zone (Windows or IANA) used to localize returned slot times. */
  userTimeZone?: string;
}

export interface GetLastCompletedSessionParams {
  /** Session type to match when selecting the last completed session. */
  sessionType?: string;
  userId?: string;
}

export interface GetManagerMixedContentsParams {
  excludeContentTypes?: string[];
  languageCode?: string;
  topics?: string[];
  /** @format int32 */
  totalCount?: number;
}

export interface GetMixedContentsV2Params {
  languageCode?: string;
  /** @format int32 */
  totalCount?: number;
}

export interface GetPagedMixedContentsV2Params {
  audience?: string;
  language?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
  type?: string[];
}

export interface GetShortsParams {
  audience?: string;
  language?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
  type?: string[];
}

export interface LoginGuestParams {
  token?: string;
}

export interface MicrosoftAspNetCoreMvcProblemDetails {
  detail?: null | string;
  instance?: null | string;
  /** @format int32 */
  status?: null | number;
  title?: null | string;
  type?: null | string;
  [key: string]: any;
}

export interface ModelsAiSearchFaqSearchResultItem {
  answer?: null | string;
  question?: null | string;
}

export interface ModelsContentsContent {
  coverImage: ModelsCoverImage;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  isBookmarked?: null | boolean;
  languageCode?: null | string;
  /** @format date-time */
  modifiedAt?: null | string;
  /** @format int32 */
  order: number;
  orientation?: null | string;
  /** @format int64 */
  parentId?: null | number;
  provider?: null | string;
  slug?: null | string;
  status?: null | string;
  themes?: null | any[];
  thumbnailPath?: null | string;
  title?: null | string;
  translations?: null | any[];
  type?: null | string;
  url?: null | string;
  userGroups?: null | any[];
  videoFormat?: null | string;
}

export interface ModelsCoverImage {
  large?: null | string;
  medium?: null | string;
  source?: null | string;
  thumbnail?: null | string;
}

/** @format int32 */
export enum ModelsDtosShortsMode {
  Include = "Include",
  Exclude = "Exclude",
  Only = "Only",
}

/** @format int32 */
export enum ModelsRequestSource {
  IsClientApp = "IsClientApp",
  IsDashboard = "IsDashboard",
  IsMobileiOS = "IsMobileiOS",
  IsMobileAndroid = "IsMobileAndroid",
  IsCustomerSuccess = "IsCustomerSuccess",
  IsSpaces = "IsSpaces",
}

export interface ModelsUserPreference {
  category?: null | string;
  name?: null | string;
  value: boolean;
}

export enum OpenUpAiCoachApiContractsApiChatMessageRole {
  User = "User",
  Assistant = "Assistant",
}

export interface OpenUpAiCoachApiContractsConversation {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastModifiedAt?: null | string;
  title?: null | string;
  [key: string]: any;
}

export interface OpenUpAiCoachApiContractsConversationSummary {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastModifiedAt?: null | string;
  title?: null | string;
  [key: string]: any;
}

export interface OpenUpAiCoachApiContractsListConversationsResponse {
  data: OpenUpAiCoachApiContractsConversationSummary[];
  pagination: OpenUpAiCoachApiContractsPageInfo;
  [key: string]: any;
}

export interface OpenUpAiCoachApiContractsPageInfo {
  hasNext: boolean;
  hasPrevious: boolean;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  [key: string]: any;
}

export interface ProviderChallengePayload {
  /** E.g. Google */
  provider?: string;
  /** The OpenUp URL responsible for handling the login response */
  redirectUrl?: string;
}

export interface RegisterGuestUserAfterCheckInParams {
  /** Is this a medical checkin */
  isMedicalCheckin?: boolean;
}

export interface RequestBookSlotRequestV2 {
  expertId?: null | string;
  expertIdsToExclude?: null | any[];
  recaptchaToken?: null | string;
  sessionContext?: null | string;
  tags: RequestTag[];
  /** @format date-time */
  time: string;
  timezone: string;
}

export interface RequestChangePasswordRequest {
  newPassword?: null | string;
  oldPassword?: null | string;
}

export interface RequestContentContentBookmarkedRequest {
  audience?: null | string;
  language?: null | string;
  themes?: null | any[];
  type?: null | any[];
}

export interface RequestContentContentEventRequest {
  /** @format int64 */
  contentId: number;
  entityId?: null | string;
  entityType?: null | string;
  eventType?: null | string;
  isRecommended?: null | boolean;
  metadata: RequestContentMetaDataRequest;
  platform?: null | string;
}

export interface RequestContentContentRequest {
  audience?: null | string;
  language?: null | string;
  themes?: null | any[];
  type?: null | any[];
}

export interface RequestContentDataRequest {
  key?: null | string;
  value?: null | string;
}

export interface RequestContentMetaDataRequest {
  data?: null | any[];
  section?: null | string;
  userAgent?: null | string;
  view?: null | string;
}

export interface RequestContentUpdateContentEngagementRequest {
  status?: null | string;
}

export interface RequestExchangeCodeForTokenRequest {
  code?: null | string;
  domain?: null | string;
  provider?: null | string;
  requestSource: ModelsRequestSource;
}

export interface RequestIdTokenRequest {
  idToken?: null | string;
  provider?: null | string;
}

/** Request object to authenticate user using login API */
export interface RequestLoginRequest {
  /**
   * @format password
   * @minLength 0
   * @maxLength 255
   */
  password: string;
  recaptchaToken?: null | string;
  /**
   * @format email
   * @minLength 1
   */
  userName: string;
}

export interface RequestRefreshTokenRequest {
  token?: null | string;
}

export interface RequestRegisterGuestUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  hasDeskJob?: null | boolean;
  isManager?: null | boolean;
  isPartner: boolean;
  lastName?: null | string;
  phoneNumber?: null | string;
  recaptchaToken?: null | string;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestRegisterUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  focusThemes?: null | any[];
  hasDeskJob?: null | boolean;
  isManager?: null | boolean;
  isPartner: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  password?: null | string;
  recaptchaToken?: null | string;
  redirectUri?: null | string;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestResetPasswordRequest {
  code?: null | string;
  password?: null | string;
  recaptchaToken?: null | string;
  /** Email */
  userId?: null | string;
}

export interface RequestSendPasswordResetEmailRequest {
  email?: null | string;
  recaptchaToken?: null | string;
  redirectUrl?: null | string;
}

export interface RequestTag {
  description?: null | string;
  tagName?: null | string;
  tagType?: null | string;
  translations?: null | any[];
}

export interface RequestUpdatePhoneNumberRequest {
  /**
   * @format tel
   * @minLength 0
   * @maxLength 20
   */
  number: string;
}

export interface RequestUpdateUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  hasDeskJob?: null | boolean;
  isAiPersonalisedRecommendationsEnabled?: null | boolean;
  isManager?: null | boolean;
  isPartner?: null | boolean;
  isTranscriptionAllowed?: null | boolean;
  languageCode?: null | string;
  lastName?: null | string;
  phoneNumber?: null | string;
  signUpToNewsletter: boolean;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestUserConfirmationSignature {
  signature?: null | string;
}

export interface RequestUsersCheckPasswordStrengthRequest {
  password?: null | string;
}

export interface RequestUsersOtpLoginRequest {
  email?: null | string;
  password?: null | string;
}

export interface ResponseContentsArticleAudioFileResponse {
  playlistUrl?: null | string;
  timingUrl?: null | string;
  voiceName?: null | string;
}

export interface ResponseContentsArticleContentResponse {
  contents?: null | any[];
  cta?: null | string;
  isDownloadable: boolean;
  large?: null | string;
  medium?: null | string;
  src?: null | string;
  text?: null | string;
  textStyle?: null | string;
  thumbnail?: null | string;
  title?: null | string;
  type?: null | string;
  url?: null | string;
  variation?: null | string;
}

export interface ResponseContentsArticleResponse {
  aiSummary?: null | string;
  audioFiles?: null | any[];
  authors?: null | any[];
  contents?: null | any[];
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  isBookmarked: boolean;
  /** @format date-time */
  modifiedAt?: null | string;
  reviewer?: null | string;
  themes?: null | any[];
  thumbnailPath?: null | string;
  title?: null | string;
  url?: null | string;
}

export interface ResponseContentsAudioContentResponse {
  /** Shared author representation for content responses (article, audio, video playback manifest). */
  author?: ResponseContentsContentAuthorResponse | null;
  contentGroups: string[];
  coverImage?: ResponseCoverImageResponse | null;
  description?: null | string;
  /** @format int32 */
  durationMs: number;
  /** @format int64 */
  id: number;
  isBookmarked?: null | boolean;
  language: string;
  themes: string[];
  title: string;
  url?: null | string;
}

export interface ResponseContentsAudioContentResponsePaginated {
  data: ResponseContentsAudioContentResponse[];
  pagination: ResponsePagination;
}

export interface ResponseContentsBookmarkContentResponse {
  /** @format int64 */
  contentId: number;
  isBookmarked: boolean;
}

/** Shared author representation for content responses (article, audio, video playback manifest). */
export interface ResponseContentsContentAuthorResponse {
  avatarUrl?: null | string;
  name?: null | string;
}

export interface ResponseContentsContentAutocompleteResponses {
  autocompleteTerms?: null | any[];
}

export interface ResponseContentsContentResponse {
  coverImage: ResponseCoverImageResponse;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  isBookmarked?: null | boolean;
  orientation?: null | string;
  /**
   * @deprecated
   * @format int32
   */
  readTime: number;
  themes?: null | any[];
  thumbnailPath?: null | string;
  title?: null | string;
  type?: null | string;
  url?: null | string;
  videoFormat?: null | string;
}

export interface ResponseContentsContentResponsePaginated {
  data: ResponseContentsContentResponse[];
  pagination: ResponsePagination;
}

export interface ResponseContentsCourseResponse {
  coverImage: ResponseCoverImageResponse;
  description?: null | string;
  /** @format int32 */
  duration: number;
  /** @format int64 */
  id: number;
  learningGoals?: null | any[];
  lessons?: null | any[];
  themes?: null | any[];
  title?: null | string;
}

export interface ResponseContentsLessonResponse {
  coverImage: ResponseCoverImageResponse;
  /** @format int32 */
  duration: number;
  engagementStatus?: null | string;
  /** @format int64 */
  id: number;
  introduction: ResponseContentsLessonResponseLessonIntroduction;
  /** @format int32 */
  lessonNo: number;
  title?: null | string;
  type?: null | string;
}

export interface ResponseContentsLessonResponseLessonIntroduction {
  description?: null | string;
  heading?: null | string;
  image: ResponseCoverImageResponse;
}

export interface ResponseContentsManagerMixedContentResponse {
  contents?: null | any[];
}

export interface ResponseContentsMixedContentResponse {
  contentCustomizedForUser: boolean;
  contents?: null | any[];
}

export interface ResponseContentsPlaybackManifestAudioResponse {
  language: string;
  url: string;
}

export interface ResponseContentsPlaybackManifestResponse {
  audio: ResponseContentsPlaybackManifestAudioResponse[];
  audioPlaylistUrl?: null | string;
  /** Shared author representation for content responses (article, audio, video playback manifest). */
  author?: ResponseContentsContentAuthorResponse | null;
  /** @format int64 */
  contentId: number;
  coverImages?: ResponseCoverImageResponse | null;
  description?: null | string;
  /** @format int32 */
  durationMs: number;
  orientation?: null | string;
  title: string;
  transcripts: ResponseContentsPlaybackManifestTranscriptResponse[];
  videoFormat?: null | string;
  videoPlaylistUrl?: null | string;
}

export interface ResponseContentsPlaybackManifestTranscriptResponse {
  language: string;
  url: string;
}

export interface ResponseContentsUpdateContentEngagementResponse {
  /** @format int64 */
  contentId: number;
  contentType?: null | string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  modifiedAt?: null | string;
  status?: null | string;
}

export interface ResponseContentsVideoResponse {
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  nativeUrl: string;
  orientation?: null | string;
  themes: string[];
  thumbnailPath: string;
  title: string;
  url: string;
  videoFormat?: null | string;
}

export interface ResponseCoverImageResponse {
  large?: null | string;
  medium?: null | string;
  source?: null | string;
  thumbnail?: null | string;
}

export interface ResponseCreateUnconfirmedUserResponse {
  signature?: null | string;
  unconfirmedDataId?: null | string;
}

export interface ResponseExternalLoginRegisterCodeFlowResponse {
  twoFactorVerification?: null | string;
  userId?: null | string;
  userTokenProviders?: null | any[];
}

export interface ResponseLoginCodeFlowResponse {
  twoFactorVerification?: null | string;
  userId?: null | string;
  userTokenProviders?: null | any[];
}

/** @format int32 */
export enum ResponseOpenUpRole {
  Automation = "Automation",
  Guest = "Guest",
  Client = "Client",
  Psychologist = "Psychologist",
  Admin = "Admin",
  Manager = "Manager",
}

export interface ResponsePagination {
  /** @format int32 */
  currentPage: number;
  hasNextPage: boolean;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  total: number;
}

export interface ResponseTwoFactorNotEnforcedConsultResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: null | string;
  clientEmail?: null | string;
  clientFirstName?: null | string;
  clientId?: null | string;
  clientTimezone?: null | string;
  consultLanguage?: null | string;
  consultType?: null | string;
  employeeFullName?: null | string;
  employeeId?: null | string;
  employeeImageUrl?: null | string;
  /** @format int32 */
  employeeNumber: number;
  employeePersonalUrlHandle?: null | string;
  employeeThumbnailUrl?: null | string;
  /** @format int32 */
  id: number;
  roomId?: null | string;
  /** @format date-time */
  startedAt: string;
  status?: null | string;
  themeKey?: null | string;
}

export interface ResponseUserPreferenceResponse {
  category?: null | string;
  name?: null | string;
  value: boolean;
}

export interface ResponseUserResponse {
  /** @format date-time */
  createdAt: string;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  employerName?: null | string;
  firstName?: null | string;
  /**
   * Boolean indicating whether the user has a valid phone number associated with their account
   * Calculated at runtime.
   */
  hasValidPhoneNumber: boolean;
  id?: null | string;
  /**
   * Whether AI personalised recommendations are enabled for the user.
   * Read from the AI_PREFERENCES / aiPersonalisedRecommendations preference; true when no record exists.
   */
  isAiPersonalisedRecommendationsEnabled: boolean;
  isEmailConfirmed: boolean;
  isFocusThemeSet: boolean;
  isGuestLogin: boolean;
  isManager: boolean;
  isPartner: boolean;
  isRegistered: boolean;
  isRegisteredWithPassword: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  loginProvider?: null | string;
  phoneNumber?: null | string;
  phoneNumberConfirmed: boolean;
  preferences?: null | any[];
  roles?: null | any[];
  signUpToNewsletter: boolean;
  twoFactorEnabled: boolean;
  /** List of external 2FA token providers set up by user */
  userTokenProviders?: null | any[];
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface SearchFaqParams {
  /** The user's question, used for semantic vector matching against the FAQ index. */
  question?: string;
}

export interface SearchV2Params {
  audience?: string;
  languageCode: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  searchTerm: string;
  /** @default 0 */
  shortsMode?: ModelsDtosShortsMode;
  types?: string[];
}

export interface SendEmailVerificationParams {
  /** The email address to which this verification link will be sent */
  email?: string;
  /** The Uri where user should be redirected after verification of the email address */
  redirectUri?: string;
}

export type SetUserCurrentMoodsPayload = string[];

export type SetUserPreferencesPayload = ModelsUserPreference[];

export interface UpdateUserPhoneNumberWithTokenParams {
  token?: string;
}
